<template>
  <section class="bg-black w-screen pt-10 pb-16 overflow-hidden">
    <BaseContainer
      :class="
        twJoin(
          'px-[50px] min-[1330px]:px-5 overflow-hidden',
          props.showNavigateDesktop && 'overflow-visible'
        )
      "
    >
      <!-- Header -->
      <header
        v-if="!props.hideTitle"
        class="pb-10 text-primary-white space-y-2 text-center md:text-left"
      >
        <h2 class="text-[32px] md:text-5xl md:leading-normal">
          {{ $t('landing.titleSocial') }}
        </h2>

        <p>
          {{ $t('landing.descSocial1') }}
          <span class="text-primary-tangerine text-xl font-bold">
            <!-- TODO: create enum -->
            @caseclub_official
          </span>

          {{ $t('landing.descSocial2') }}
          <!-- TODO: create enum -->
          {{ $t('landing.descSocial1') }} @caseclub_official
          {{ $t('landing.descSocial3') }}
        </p>
      </header>

      <!-- Content -->
      <section class="relative">
        <div
          :class="
            twJoin(
              '!hidden md:!flex social-c-button-prev absolute -left-[25px] min-[1330px]:-left-[40px] top-[50%] -translate-x-1/2 -translate-y-1/2 w-8 h-8 items-center justify-center rounded bg-white text-black cursor-pointer',
              props.showNavigateDesktop && '!flex max-md:hidden'
            )
          "
        >
          <Icon name="arrow-left" />
        </div>

        <nuxt-error-boundary @error="() => {}">
          <Swiper
            class="!flex md:!hidden !overflow-visible"
            :modules="[
              SwiperAutoplay,
              SwiperEffectCreative,
              SwiperEffectCoverflow,
              SwiperNavigation
            ]"
            :navigation="{
              enabled: true,
              disabledClass: '!bg-gray-10 !text-typo-disabled',
              nextEl: '.social-c-button-next',
              prevEl: '.social-c-button-prev'
            }"
            :effect="'coverflow'"
            :grab-cursor="true"
            :centered-slides="true"
            :slides-per-view="'auto'"
            :coverflow-effect="{
              rotate: 50,
              stretch: 0,
              depth: 100,
              modifier: 1,
              slideShadows: true
            }"
            :autoplay="{
              delay: 6000,
              disableOnInteraction: true
            }"
          >
            <SwiperSlide v-for="(slide, index) in slides" :key="index">
              <Suspense
                ><CommunityProductReviewComponent
                  :key="index"
                  :title="slide.title"
                  :image-url="slide.imageUrl"
                  :href="slide.primaryButtonHref"
              /></Suspense>
            </SwiperSlide>
          </Swiper>
        </nuxt-error-boundary>
        <nuxt-error-boundary @error="() => {}">
          <Swiper
            class="!hidden md:!flex"
            :modules="[SwiperAutoplay, SwiperEffectCreative, SwiperNavigation]"
            :slides-per-view="'auto'"
            :space-between="15"
            :navigation="{
              enabled: true,
              disabledClass: '!bg-gray-10 !text-typo-disabled',
              nextEl: '.social-c-button-next',
              prevEl: '.social-c-button-prev'
            }"
            :creative-effect="{
              prev: {
                shadow: false,
                translate: ['-20%', 0, -1]
              },
              next: {
                translate: ['100%', 0, 0]
              }
            }"
            :autoplay="{
              delay: 6000,
              disableOnInteraction: true
            }"
          >
            <SwiperSlide
              v-for="(slide, index) in slides"
              :key="index"
              class="min-w-[240px] max-w-[240px] md:max-w-[282px]"
            >
              <Suspense
                ><CommunityProductReviewComponent
                  :key="index"
                  :title="slide.title"
                  :image-url="slide.imageUrl"
                  :href="slide.primaryButtonHref"
              /></Suspense>
            </SwiperSlide>
          </Swiper>
        </nuxt-error-boundary>
        <div
          :class="
            twJoin(
              '!hidden md:!flex social-c-button-next absolute -right-[25px] min-[1330px]:-right-[40px] top-[50%] translate-x-1/2 -translate-y-1/2 w-8 h-8 items-center justify-center rounded bg-white text-black cursor-pointer',
              props.showNavigateDesktop && '!flex max-md:hidden'
            )
          "
        >
          <Icon name="arrow-right" />
        </div>
      </section>
    </BaseContainer>
  </section>
</template>
<script lang="ts" setup>
// TODO: revise script code
import { cmsRepository } from '~/repository/cmsRepository'
import { twJoin } from 'tailwind-merge'

const CommunityProductReviewComponent = defineAsyncComponent({
  loader: () => import('../components/CommunityProductReview.vue')
})

const { $serverApi } = useNuxtApp()
const cmsRepo = cmsRepository($serverApi)
const props = defineProps<{
  hideTitle?: boolean
  showNavigateDesktop?: boolean
}>()

const { data: slides } = await useAsyncData<
  {
    title: string
    imageUrl: string
    primaryButtonHref: string
  }[]
>(
  'getLandingPageCommunity',
  async () => {
    const response = await cmsRepo.getWidget('landing-page-community')
    if (response.data.data.items) return response.data.data.items
    return null
  },
  { server: false }
)
</script>
